import { colors } from '../variables';
import { ThemeType } from './default';
import { hexToRgbaString } from '../../src/color-utils';

const darkTheme: ThemeType = {
  bg: {
    primary: '#404040',
    secondary: colors.darkGray4,
    overlay: '#000',
  },
  header: {
    bg: colors.lightBlue1,
    fg: colors.white,
  },
  footer: {
    bg: {
      primary: colors.lightBlue3,
      secondary: colors.lightGray1,
    },
    fg: {
      primary: colors.semiWhite,
    },
  },
  text: {
    primary: 'white',
    secondary: '#eee',
    tertiary: '#bbb',
    quaternary: '#aaa',
    linkExternal: colors.lightBlue3,
    linkExternalHover: colors.green1,
    linkInternal: colors.white,
    linkInternalHover: colors.white,
    callToAction: colors.lightBlue1,
    callToActionHover: colors.green1,
    negative: colors.red1,
  },
  icons: {
    primary: colors.darkGray4,
    secondary: colors.darkGray2,
    tertiary: colors.mediumGray1,
    quaternary: colors.lightGray2,
    light: colors.mediumGray2,
    callToAction: colors.lightBlue3,
    callToActionHover: colors.green1,
  },
  lines: {
    primary: '#303030',
    secondary: '#202020',
    tertiary: '#101010',
    quaternary: '#000',
  },
  buttons: {
    primary: {
      bg: colors.lightBlue3,
      text: colors.white,
      textHover: colors.white,
    },
    secondary: {
      bg: colors.darkGray1,
      text: colors.white,
      textHover: colors.white,
    },
    tertiary: {
      bg: colors.darkGray4,
      text: colors.white,
      textHover: colors.white,
      textWithoutBackground: colors.white,
      textWithoutBackgroundHover: colors.lightGray2,
    },
    quarternary: {
      bg: colors.darkBlue1,
      text: colors.white,
      textHover: colors.white,
    },
    positive: {
      bg: colors.darkGreen1,
      text: colors.white,
      textHover: colors.white,
    },
    negative: {
      bg: colors.red1,
      text: colors.white,
      textHover: colors.white,
    },
    link: {
      bg: 'transparent',
      text: colors.lightBlue3,
      textHover: colors.green1,
    },
    disabled: {
      bg: colors.darkGray1,
      text: colors.white,
      textHover: colors.white,
    },
    category: {
      bg: '#404040',
      bgActive: colors.darkGray4,
      text: colors.white,
      textHover: colors.semiWhite,
    },
  },
  pill: {
    primary: {
      bg: colors.lightBlue3,
      text: colors.white,
    },
  },
  inputs: {
    primary: {
      bg: colors.white,
      border: colors.darkGray1,
      borderFocus: colors.lightBlue2,
    },
  },
  dropdowns: {
    primary: {
      bg: colors.white,
      hoverBackground: hexToRgbaString(colors.lightBlue3, 0.2),
      borderRadius: '5px',
      borderColor: {
        active: colors.darkBlue1,
        inactive: colors.darkBlue1,
      },
    },
    secondary: {
      bg: colors.white,
      hoverBackground: hexToRgbaString(colors.lightBlue3, 0.2),
      borderRadius: 0,
      borderColor: {
        active: colors.lightGray1,
        inactive: 'transparent',
      },
    },
  },
};

export default darkTheme;
